import { render, staticRenderFns } from "./BlockWithActions.vue?vue&type=template&id=526f1cf6&scoped=true&"
import script from "./BlockWithActions.vue?vue&type=script&lang=js&"
export * from "./BlockWithActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f1cf6",
  null
  
)

export default component.exports